module.exports = __webpack_public_path__ + "img/empty_rental_icon.329a2e19.svg";